import { Drawer, List } from '@mui/material';
import '../styleDrawerConstruct.css';
import CantonContainerViewing from '../../Optics/Drawer/DrawerViewing/ContainerViewing/CantonContainerViewing';
import LineSectorFilterContainerViewing from './ViewingContainer/LineSectorFilterContainerViewing';
import { ROLE_ADMIN, ROLE_ENGINNER, ROLE_USER } from '../../Optics/Constants/ConstantsOptics';

//#region STYLE
  const customStyles = {
    control: base => ({
      ...base,
      background: '#4b4b4b',
      borderRadius: '5px',
      fontSize: '16px',
      border: '1px solid #ffffff',
      marginBottom: '5px',
    }),
    singleValue: base => ({
      ...base,
      color: '#ffffff', 
    }),
    input: base => ({
      ...base,
      color: '#ffffff', 
    }),
    menu: base => ({
      ...base,
      background: '#4b4b4b',
      color: '#ececec', 
    }),
    option: (base, { isFocused }) => ({
      ...base,
      backgroundColor: isFocused ? '#bdbdbd' : 'transparent', 
      color: isFocused ? '#000000' : '#ececec', 
    }),
  };
//#endregion 

const DrawerViewingWifi = ({ openViewingDrawer, toggleViewingDrawer,loadingCunton, canton, handleCantonChange,handleRegionChange,
      selectedRegionRef,regions,handleAreaChange, selectedAreaRef,area,handleClickCanton, selectCantonIsСhange, selectedRegoin,selectedArea, 
      handleSectorCheckboxChange, showWifiCoverage, handleLinePointToPointWifiCheckboxChange, showLinePointToPointWifi,
      handleLineSwToPointWifiCheckboxChange, showLineSwToPointWifi, handleSwitchCheckboxChange, showSwitch, handleBaseStationCheckboxChange,
      showBaseStation, handleStationCheckboxChange, showStation, handleApCheckboxChange, showAp, handleHousesActivChange, showHousesActiv,
      handleHousesNoActivChange, showHousesNoActiv, handleSwRank3Change, showRank3, handleSwRank12Change, showRank12}) => { 

           const roleId = localStorage.getItem('roleId');
                  const territory = localStorage.getItem('territory');
        
                  const allowedRoles = [ROLE_ADMIN, ROLE_ENGINNER, ROLE_USER];
                  const showHighwayContainer = allowedRoles.includes(roleId);
        
                  const cantonToUse = getFilteredCanton(territory, canton, roleId);
        
                  function getFilteredCanton(territoryRaw, canton, roleId) {
                    const userTerritory = (territoryRaw || '').trim();
        
                    if (roleId === ROLE_ADMIN || roleId === ROLE_ENGINNER) {
                      return canton; // полный доступ
                    }
        
                    if (userTerritory.toLowerCase() === 'full') {
                      return canton;
                    }
        
                    if (!userTerritory) {
                      return []; // ничего не передаём
                    }
        
                    const normalizedCanton = canton.map(c => c.trim());
                    return normalizedCanton.includes(userTerritory) ? [userTerritory] : [];
                  }
      
              
  return (
    <Drawer
      open={openViewingDrawer}
      onClose={toggleViewingDrawer(false)}
      PaperProps={{ className: 'drawerBackground hideScrollbar', style: { width: "260px" } }}
     
    >
      <div className="divTitleDrawerConstr">
        <p className='textTitleDrawer'>Wi-Fi</p>
      </div>

      <List>
        <div style={{paddingLeft:'5px', paddingRight: '5px'}}>

         {/* Просмотр территории округ / регион / ветка */}
              <CantonContainerViewing
                handleCantonChange={handleCantonChange}
                canton={cantonToUse}
                customStyles={customStyles}
                handleRegionChange={handleRegionChange}
                regions={regions}
                area={area}
                handleClickCanton={handleClickCanton}
                loadingCunton={loadingCunton}
                selectedRegionRef={selectedRegionRef}
                selectedAreaRef={selectedAreaRef}
                handleAreaChange={handleAreaChange}
                selectCantonIsСhange={selectCantonIsСhange}
                selectedRegoin={selectedRegoin}
                selectedArea={selectedArea}
              />
           
            {/* фильтр линков-секторов */}
            <LineSectorFilterContainerViewing
              handleSectorCheckboxChange={handleSectorCheckboxChange}
              showWifiCoverage={showWifiCoverage}
              handleLinePointToPointWifiCheckboxChange={handleLinePointToPointWifiCheckboxChange}
              showLinePointToPointWifi={showLinePointToPointWifi}
              handleLineSwToPointWifiCheckboxChange={handleLineSwToPointWifiCheckboxChange}
              showLineSwToPointWifi={showLineSwToPointWifi}
              handleSwitchCheckboxChange={handleSwitchCheckboxChange}
              showSwitch={showSwitch}
              handleBaseStationCheckboxChange={handleBaseStationCheckboxChange}
              showBaseStation={showBaseStation}
              handleStationCheckboxChange={handleStationCheckboxChange}
              showStation={showStation}
              handleApCheckboxChange={handleApCheckboxChange}
              showAp={showAp}
              handleHousesActivChange={handleHousesActivChange}
              showHousesActiv={showHousesActiv}
              handleHousesNoActivChange={handleHousesNoActivChange}
              showHousesNoActiv={showHousesNoActiv}
              handleSwRank3Change={handleSwRank3Change}
              showRank3={showRank3}
              handleSwRank12Change={handleSwRank12Change}
              showRank12={showRank12}
            />              
           </div> 
       
      </List>
    </Drawer>    
  );
};

export default DrawerViewingWifi;